type Props = {
  label: string;
  value: string;
  delta: string;
  deltaTrend: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  suffix: string;
};

export default function StatCard({
  label,
  value,
  delta,
  deltaTrend,
  icon,
  iconBg,
  iconColor,
  suffix,
}: Props) {
  const trendColor =
    deltaTrend === "up"
      ? "text-emerald-600"
      : deltaTrend === "down"
        ? "text-rose-600"
        : "text-ink-500";
  const trendIcon =
    deltaTrend === "up"
      ? "ri-arrow-up-line"
      : deltaTrend === "down"
        ? "ri-arrow-down-line"
        : "ri-pulse-line";

  return (
    <div className="bg-white border border-ink-100 rounded-lg p-5 hover:border-ink-200 transition-colors">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-11 h-11 flex items-center justify-center rounded-md ${iconBg}`}>
          <i className={`${icon} ${iconColor} text-xl`}></i>
        </div>
        <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-cream-100 text-ink-400 cursor-pointer">
          <i className="ri-more-2-fill text-sm"></i>
        </button>
      </div>
      <div className="text-xs font-medium text-ink-500 uppercase tracking-wider mb-1.5">{label}</div>
      <div className="font-display text-3xl font-bold text-ink-900 leading-none mb-3">{value}</div>
      <div className="flex items-center gap-1.5 text-xs">
        <span className={`inline-flex items-center gap-0.5 font-semibold ${trendColor}`}>
          <i className={`${trendIcon} text-sm`}></i>
          {delta}
        </span>
        <span className="text-ink-400">{suffix}</span>
      </div>
    </div>
  );
}